import {User} from '@app/core/models/user.model';
import {Shift} from '@app/core/models/shift.model';
import {FileEntry} from '@app/core/models/fileEntry.model';
import {Subscription} from 'rxjs/Subscription';
import {HttpService} from '@app/core/services/http.service';
import {BulletinBoardPostComment} from '@app/core/models/bulletinBoardPostComment.model';
import {BulletinBoardPostLike} from '@app/core/models/bulletinBoardPostLike.model';
import {RDate} from '@app/core/models/rDate.model';
import {Group} from '@app/core/models/group.model';
import {Department} from '@app/core/models/department.model';
import {BaseModel} from '@app/core/models/base.model';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {IQOIconsOverlap} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-icons-overlap.interface';

export class BulletinBoardPost extends BaseModel {
	public subscriptions: Subscription[] = [];
	public id: number;
	public content: string;
	public created_at: RDate;
	public updated_at: RDate;
	public user: User;
	public file_entries: FileEntry[];
	public shifts: Shift[];
	public message_board_post_comments_count: number = 0;
	public message_board_post_likes_count: number = 0;
	public seen_by_count: number = 0;
	public comments: BulletinBoardPostComment[] = [];
	public likes: BulletinBoardPostLike[] = [];
	public liked: boolean;
	public groups: Group[] = [];
	public departments: Department[] = [];
	public deleted_at: RDate;
	public latest_message_board_post_comment: BulletinBoardPostComment;
	public latest_four_message_board_post_likes: BulletinBoardPostLike[];
	public overlappingLikeIcons?: IQOIconsOverlap[];
	public comment?: string;

	constructor(
		public httpService: HttpService,
		public userModel: boolean = true,
		public tenantTZ: string,
		interService: InternationalizationService,
	) {
		super(tenantTZ, interService);
	}

	public deserialize(input: any): any {
		Object.assign(this, input);
		if (input.shifts) {
			this.shifts = input.shifts.map(shiftInput => new Shift(this.tenantTZ, this.interService).deserialize(shiftInput));
		}
		if (input.file_entries) {
			this.file_entries = input.file_entries.map(
				fileEntryInput => new FileEntry(this.tenantTZ, this.interService).deserialize(fileEntryInput),
			);
		}

		if (input.user) {
			this.user = new User(this.tenantTZ, this.interService).deserialize(input.user);
		}

		if (input.created_at) {
			this.created_at = new RDate(this.tenantTZ, this.interService).deserialize(input.created_at);
		}

		if (input.updated_at) {
			this.updated_at = new RDate(this.tenantTZ, this.interService).deserialize(input.updated_at);
		}

		return this;
	}

}
